"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const dialogContext_1 = require("./dialogContext");
const DialogFooter = (props) => {
    const { className = '', children, ...remainingProps } = props;
    const { isSmallestDialog, showXsDialogBorders } = (0, dialogContext_1.useDialogContext)();
    const doShowXsDialogBorders = isSmallestDialog ? showXsDialogBorders : true;
    const footerClassNames = (0, classnames_1.default)('modal-footer', !doShowXsDialogBorders && 'border-top-none padding-top-0', className);
    return ((0, jsx_runtime_1.jsx)("div", { ...remainingProps, className: footerClassNames, "aria-label": 'dialog footer', children: children }));
};
exports.default = DialogFooter;
